import { ca } from '@cian/analytics';
import { plural } from '@cian/utils/lib/shared/plural';
import * as React from 'react';
import { INewbuildingInfo } from '../../../../api/newbuildings';
import { Gallery, GalleryImage } from '../../../../common/components/gallery/index';
import { UndergroundIcon } from '../../../../common/components/underground_icon';
import { ERoomType } from '../../../../json_query';
import { IBreadcrumb } from '../../../../offer';
import BusinessCardContainer from '../business_card/container';
import { FavoriteButtonContainer } from '../favorite_button/container';
import { Breadcrumbs } from '../../Breadcrumbs';
import { ProblemPopup } from '../problem_popup';
import { ReliablePopup } from '../reliable_popup';

const style = require('./index.css');

export interface IHeaderNewbuildingProps {
  breadcrumbs: IBreadcrumb[];
  seoTitle: string | undefined;
  newbuildingInfo: INewbuildingInfo;
  roomType: ERoomType[];
  isFromDeveloper: boolean;
}

const roomTypeMap = {
  [ERoomType.Room]: 'комнату',
  [ERoomType.FlatOneRoom]: 'однокомнатную квартиру',
  [ERoomType.FlatTwoRooms]: 'двухкомнатную квартиру',
  [ERoomType.FlatThreeRooms]: 'трехкомнатную квартиру',
  [ERoomType.FlatFourRooms]: 'четырехкомнатную квартиру',
  [ERoomType.FlatFiveRooms]: 'пятикомнатную квартиру',
  [ERoomType.FlatManyRooms]: 'многокомнатную квартиру',
  [ERoomType.FlatFreeLayout]: 'квартиру свободной планировки',
  [ERoomType.FlatShared]: 'долю в квартире',
  [ERoomType.Studio]: 'квартиру-студию',
  [ERoomType.Bed]: 'койко-место',
};

export class HeaderNewbuilding extends React.Component<IHeaderNewbuildingProps> {
  public render() {
    const { seoTitle, isFromDeveloper, newbuildingInfo, roomType, breadcrumbs } = this.props;
    const newBuildingUrl = newbuildingInfo.fullUrl || newbuildingInfo.url;

    return (
      <div className={style.container}>
        <div className={style.wrapper}>
          <Breadcrumbs breadcrumbs={breadcrumbs} />
          {seoTitle && <h1 className={style.title}>{seoTitle}</h1>}
          {!seoTitle && (
            <h1 className={style.title}>
              Купить {roomType.length === 1 ? roomTypeMap[roomType[0]] : 'квартиру'} в&nbsp;
              <a href={newBuildingUrl} target="_blank">
                ЖК {newbuildingInfo.name}
              </a>
            </h1>
          )}
          <div className={style['content']}>
            <div className={style['content-main']}>
              <div className={style['content-title']}>
                <a href={newBuildingUrl} target="_blank" onClick={this.trackNewbuildingTitleClick}>
                  ЖК &laquo;{newbuildingInfo.name}&raquo;
                </a>
                <div className={style['favorite-button-container']}>
                  <FavoriteButtonContainer />
                </div>
                {newbuildingInfo.isReliable && !!newBuildingUrl && (
                  <ReliablePopup url={newBuildingUrl} GKId={newbuildingInfo.id} />
                )}
                {newbuildingInfo.isProblem && !!newBuildingUrl && (
                  <ProblemPopup url={newBuildingUrl} GKId={newbuildingInfo.id} />
                )}
              </div>
              <div className={style['content-info']}>
                <span className={style['content-status']}>{newbuildingInfo.status}</span>
                <span className={style['content-address']}>{newbuildingInfo.address}</span>
              </div>
              {this.renderMetro()}
              {newbuildingInfo.seoDescription && (
                <div className={style['content-description']}>{newbuildingInfo.seoDescription}</div>
              )}
              <div className={style['content-link']}>
                <a href={newBuildingUrl} target="_blank">
                  Подробнее о ЖК
                </a>
              </div>
              {isFromDeveloper && <BusinessCardContainer />}
            </div>
            {this.renderGallery()}
          </div>
        </div>
      </div>
    );
  }

  private trackNewbuildingTitleClick = () => {
    const { moId, oblId, cityId } = this.props.newbuildingInfo.trackingData;

    ca('event', {
      name: 'oldevent',
      category: 'Listing',
      action: 'to_card_newbuilding',
      label: `/jk_head_block/newobject_name/mo_id=${moId}/obl_id=${oblId}/city_id=${cityId}/`,
    });
  };

  private renderGallery() {
    const { newbuildingInfo } = this.props;

    if (!newbuildingInfo.images) {
      return null;
    }

    const firstImage = newbuildingInfo.images[0];
    const firstImageUrl = firstImage ? firstImage : '';

    return (
      <div className={style['content-gallery']}>
        <span {...{ itemProp: 'image', content: firstImageUrl }} />
        <Gallery>
          {newbuildingInfo.images.map((image, index) => (
            <GalleryImage key={`image-${index}`} src={image} />
          ))}
        </Gallery>
      </div>
    );
  }

  private renderMetro() {
    const { newbuildingInfo } = this.props;

    if (!newbuildingInfo.metro) {
      return null;
    }

    return (
      <div className={style['content-metro']}>
        <UndergroundIcon
          width={16}
          height={16}
          color={newbuildingInfo.metro.color}
          regionId={newbuildingInfo.metro.regionId}
        />
        <span>{`${newbuildingInfo.metro.name}${newbuildingInfo.metro.travelTime ? ', ' : ''}`}</span>
        {newbuildingInfo.metro.travelTime && (
          <span className={style['content-travelTime']}>
            {/* tslint:disable-next-line:max-line-length */}
            {`${newbuildingInfo.metro.travelTime} ${plural(newbuildingInfo.metro.travelTime, [
              'минута',
              'минуты',
              'минут',
            ])} ${newbuildingInfo.metro.isOnTransport ? 'на транспорте' : 'пешком'}`}
          </span>
        )}
      </div>
    );
  }
}
